import LinkExternalIcon from "@redotech/redo-icons/link-external-02.svg";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { RedoButton } from "@redotech/redo-web/arbiter-components/buttons/redo-button";
import { RedoModal } from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { RECLAIM_INSTALL_APP_MODAL_UI_SELECTOR } from "./constants";
import * as css from "./reclaim-install-app-modal.module.css";

const RECLAIM_PROMPT_IMAGE_URL =
  "https://redoapi-dev.s3.us-east-1.amazonaws.com/redo/static/onboarding-v2/shopify-image.webp";

export const ReclaimInstallAppModal = memo(function ReclaimInstallAppModal({
  deferPending,
  onDefer,
  onOpenListing,
}: {
  deferPending: boolean;
  onDefer: () => void;
  onOpenListing: () => void;
}) {
  return (
    <RedoModal
      className={css.modal}
      hideFooter
      hideHeader
      isOpen
      modalSize="md"
      muiClassName={css.backdropBlur}
      noPadding
      onModalCloseRequested={ignoreModalClose}
      title="Finish connecting Reclaim in Shopify"
      uiSelector={RECLAIM_INSTALL_APP_MODAL_UI_SELECTOR}
    >
      <Flex className={css.frame} dir="row" gap="none" w="full">
        <Flex
          basis="205px"
          bgColor="secondary"
          borderBottomLeftRadius="3xl"
          borderTopLeftRadius="3xl"
          className={css.imagePane}
          overflow="hidden"
          position="relative"
          shrink={0}
        >
          <img
            alt=""
            aria-hidden
            className={css.image}
            src={RECLAIM_PROMPT_IMAGE_URL}
          />
        </Flex>

        <Flex
          aria-label="Finish connecting Reclaim in Shopify"
          as="section"
          basis="calc(100% - 191px)"
          bgColor="primary"
          borderRadius="3xl"
          className={css.contentCard}
          dir="column"
          gap="xl"
          p="3xl"
          shadow="lg"
          shrink={0}
        >
          <Flex dir="column" flex={1} gap="xl" justify="space-between">
            <Flex dir="column" gap="sm">
              <Flex>
                <RedoBadge color="blueLight" size="sm" text="30 seconds" />
              </Flex>
              <Text
                as="h2"
                data-testid="reclaim-install-app-modal-title"
                fontSize="xl"
                fontWeight="semibold"
                textColor="primary"
              >
                Finish connecting Reclaim in Shopify
              </Text>
              <Text fontSize="sm" textColor="secondary">
                Reclaim now uses a dedicated Shopify app connection. Connecting
                it keeps your existing chargeback automation aligned with
                Shopify.
                <br />
                <br />
                You'll continue using the same Redo platform, dashboard,
                workflows, and settings. Your current setup stays the same.
              </Text>
            </Flex>

            <Flex align="center" gap="sm" justify="flex-end" w="full">
              <RedoButton
                hierarchy="secondary"
                onClick={onDefer}
                pending={deferPending}
                size="sm"
                text="Remind me later"
              />
              <RedoButton
                hierarchy="primary"
                IconLeading={LinkExternalIcon}
                onClick={onOpenListing}
                size="sm"
                text="Connect Reclaim app"
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </RedoModal>
  );
});

function ignoreModalClose(): void {
  // Intentional no-op: this prompt should only defer from "Remind me later".
}
